module.exports = __webpack_public_path__ + "img/elvis-fanday-84.2d73d738.jpg";